import { gql } from "@apollo/client";
import { ContactPersonFields } from "../fragments/contactPersonFields";

export const UpdateContactPerson = gql`
    mutation UpdateContactPerson($id: ID!, $input: ContactPersonUpdateAttributesInput!) {
        updateContactPerson(id: $id, input: $input) {
            ...ContactPersonFields
        }
    }
    ${ContactPersonFields}
`;
